import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  run: null,
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  { run }: Boundaries["retrieveExportBiRun"]["success"],
): State {
  return { ...state, request: setRequestStateToSuccess(), run };
}

function handleFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function handleRequestExportBiRun(
  state: State,
  { run }: Boundaries["requestExportBiRun"]["success"],
): State {
  return { ...state, run };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveExportBiRunRequested]: handleRequest,
    [events.retrieveExportBiRunSucceeded]: handleSuccess,
    [events.retrieveExportBiRunFailed]: handleFailure,
    [events.requestExportBiRunSucceeded]: handleRequestExportBiRun,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
